import { render, staticRenderFns } from "./oilPrice.vue?vue&type=template&id=3b9c3282&scoped=true&"
import script from "./oilPrice.vue?vue&type=script&lang=js&"
export * from "./oilPrice.vue?vue&type=script&lang=js&"
import style0 from "./oilPrice.vue?vue&type=style&index=0&id=3b9c3282&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9c3282",
  null
  
)

export default component.exports